__turbopack_context__.v({
  "body": "dialog-module-scss-module__WWDohG__body",
  "close": "dialog-module-scss-module__WWDohG__close",
  "content": "dialog-module-scss-module__WWDohG__content",
  "footer": "dialog-module-scss-module__WWDohG__footer",
  "footerAction": "dialog-module-scss-module__WWDohG__footerAction",
  "header": "dialog-module-scss-module__WWDohG__header",
  "mantineBody": "dialog-module-scss-module__WWDohG__mantineBody",
  "title": "dialog-module-scss-module__WWDohG__title",
});
